<div class="vast-endpoint">
  <div class="vast-endpoint__content">
    <div class="form-group">
      <div class="textarea-wrapper">
        <nz-input-group
          [nzSuffix]="copyIcon"
          class="ant-input-affix-wrapper-textarea-with-copy-btn"
        >
          <textarea
            nz-input
            [(ngModel)]="endpointUrl"
            placeholder="textarea with copy icon"
            name="endpointUrl"
            [disabled]="true"
          ></textarea>
        </nz-input-group>
        <ng-template #copyIcon>
          <span
            nz-icon
            class="ant-input-copy-icon"
            nzTheme="fill"
            nzType="copy"
            (click)="linkCopy()"
            [cbContent]="endpointUrl"
            ngxClipboard
          ></span>
        </ng-template>
      </div>
    </div>
    <div class="macros-group">
      <div class="col-9">
        <nz-select
          nzShowSearch
          [nzShowArrow]="true"
          nzMode="multiple"
          nzPlaceHolder="Select Marcos"
          name="macros"
          [nzMaxTagCount]="15"
          [nzMaxTagPlaceholder]="tagPlaceHolder"
          (ngModelChange)="changeMacros($event)"
          [(ngModel)]="selectedMacrosList"
        >
          <nz-option
            *ngFor="let macros of macrosListVast"
            [nzValue]="macros.id"
            [nzLabel]="macros.name"
          >
          </nz-option>
        </nz-select>
        <ng-template #tagPlaceHolder let-omittedValues
          >and {{ omittedValues.length }} more...</ng-template
        >
      </div>
      <div class="col-2">
        <div class="form-grouo">
          <button
            nz-button
            nzType="default"
            type="button"
            *ngIf="adServer === null"
            (click)="openMacros()"
          >
            Macros List
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
